









import { Component, Vue } from 'vue-property-decorator'
import { vxm } from '@/store'

@Component({
  components: {}
})
export default class UserWelcome extends Vue {
  // Lifecycle hooks
  created() {}
  mounted() {}
  updated() {}
  destroyed() {}
}
